import {Scroll} from 'platform/foundation';

import {Nullish, suffixTestId, TestIdProps, useBoolean} from 'shared/web';

import {DataStatus} from '../DataStatus/DataStatus';
import {DropdownContainer} from '../Dropdown/components/DropdownContainer';
import {DropdownItem} from '../Dropdown/components/DropdownItem';
import {MobileMenuTrigger} from './components/MobileMenuTrigger';

export interface MobileMenuOption {
  value: string;
  label: string;
  isDisabled?: boolean;
}

export interface MobileMenuProps extends TestIdProps {
  options: MobileMenuOption[];
  value: string | Nullish;
  placeholder?: string;
  isDisabled?: boolean;
  onClick: (value: string) => void;
}

const MAX_SCROLLABLE_LIST_HEIGHT = 68; // To show max 7.5 items in the list (7.5 * 36) / 4

export function MobileMenu(props: MobileMenuProps) {
  const [isOpen, open, close] = useBoolean();

  const selectedOption = props.options.find((option) => option.value === props.value);
  const triggerLabel = selectedOption?.label ?? props.placeholder;

  return (
    <DropdownContainer
      isOpen={isOpen}
      onOpen={open}
      onClose={close}
      isMatchingReferenceWidth
      placement="bottom"
      isDisabled={props.isDisabled}
      dropdownControl={
        <MobileMenuTrigger
          label={triggerLabel}
          isOpen={isOpen}
          isDisabled={props.isDisabled}
          data-testid={suffixTestId('mobileMenuTrigger', props)}
        />
      }
      data-testid={suffixTestId('mobileMenu', props)}
    >
      <DataStatus
        isEmpty={props.options.length === 0}
        data-testid={suffixTestId('dataStatus', props)}
      >
        <Scroll maxHeight={MAX_SCROLLABLE_LIST_HEIGHT} auto hasHiddenScrollBars>
          {props.options.map((option) => (
            <DropdownItem
              key={option.value}
              label={option.label}
              isActive={option.value === props.value}
              isDisabled={option.isDisabled}
              onClick={() => props.onClick(option.value)}
              data-testid={suffixTestId(`mobileMenu-option-[${option.value}]`, props)}
            />
          ))}
        </Scroll>
      </DataStatus>
    </DropdownContainer>
  );
}
